"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptForSaveFile = exports.PromptForOpenFile = exports.PromptForFolder = exports.FileBrowserModal = void 0;
const React = __importStar(require("react"));
const react_modal_1 = __importDefault(require("react-modal"));
const file_browser_container_1 = require("./file-browser-container");
const utilities_1 = require("../utilities");
const file_browser_context_1 = require("./file-browser-context");
const z_index_1 = require("../z-index");
/** React component for showing a file browsing UI in a modal.
 * @description If you're not using React, or don't have a convenient place for this component to live,
 * consider using the PromptForFile() or PromptForFolder() functions, which render the component in a throwaway <div />
 */
function FileBrowserModal({ Show, FileService, InitialFolder, InitialFilename, Dimensions, Context, Title, ContentStyle, OverlayStyle, TitleStyle, FileGroups, HideHorizontalToolbar, HideUploadOption, ShowMyComputer, UserName }) {
    Dimensions = Dimensions || { Width: 800, Height: 600, MaxHeight: "90%", MaxWidth: "90%" };
    const title = Title || GetDefaultTitle(Context);
    const titleRowHeight = 32;
    const writeDimension = (dimension) => typeof dimension === "number"
        ? `${dimension}px`
        : dimension;
    // https://github.com/reactjs/react-modal/issues/62
    const verticalCenterStyle = {
        minHeight: '10rem',
        left: '50%',
        position: 'fixed',
        right: 'auto',
        top: '50%',
        transform: 'translate(-50%,-50%)',
        minWidth: '20rem',
        bottom: "initial"
    };
    const contentStyle = Object.assign(Object.assign({}, verticalCenterStyle), ContentStyle || {});
    const overlayStyle = Object.assign({
        zIndex: z_index_1.modalZIndex
    }, OverlayStyle || {});
    const titleStyle = Object.assign(Object.assign({}, (TitleStyle || {})), { height: `${titleRowHeight}px` });
    return React.createElement(react_modal_1.default, { isOpen: Show, onRequestClose: () => Context.OnSubmit(null), style: {
            content: Object.assign(Object.assign({}, contentStyle), { width: writeDimension(Dimensions.Width), height: writeDimension(Dimensions.Height), maxWidth: Dimensions.MaxWidth ? writeDimension(Dimensions.MaxWidth) : undefined, maxHeight: Dimensions.MaxHeight ? writeDimension(Dimensions.MaxHeight) : undefined, padding: 0, overflow: "initial" // Needed for defined-height modal
             }),
            overlay: overlayStyle
        }, ariaHideApp: false },
        React.createElement("div", { className: "modal-title border-bottom no-select", style: titleStyle }, title),
        React.createElement(file_browser_container_1.FileBrowserContainer, { FileService: FileService, Cancel: () => Context.OnSubmit(null), InitialFolder: InitialFolder || null, InitialFilename: InitialFilename || null, style: { height: `calc(100% - ${titleRowHeight}px)` }, Context: Context, FileGroups: FileGroups || "All", HideHorizontalToolbar: HideHorizontalToolbar, HideUploadOption: HideUploadOption, ShowMyComputer: ShowMyComputer, UserName: UserName || null }));
}
exports.FileBrowserModal = FileBrowserModal;
/** Show a folder browser UI
 * @description Uses a temporary element which is removed
 * after the interaction is complete.
 */
function PromptForFolder(props) {
    return __awaiter(this, void 0, void 0, function* () {
        return utilities_1.ShowReactPromise((resolve, reject) => {
            const modalProps = Object.assign(Object.assign({}, props), { Show: true, Context: file_browser_context_1.CompleteFolderContext(props.Context || { Type: "OpenFolder" }, resolve) });
            return React.createElement(FileBrowserModal, Object.assign({}, modalProps));
        });
    });
}
exports.PromptForFolder = PromptForFolder;
/** Show a file browser UI
 * @description Uses a temporary element which is removed
 * after the interaction is complete.
 */
function PromptForOpenFile(props) {
    return __awaiter(this, void 0, void 0, function* () {
        return utilities_1.ShowReactPromise((resolve, reject) => {
            const modalProps = Object.assign(Object.assign({}, props), { Show: true, Context: {
                    Type: "OpenFile",
                    OnSubmit: resolve
                } });
            return React.createElement(FileBrowserModal, Object.assign({}, modalProps));
        });
    });
}
exports.PromptForOpenFile = PromptForOpenFile;
/** Show a file browser UI
 * @description Uses a temporary element which is removed
 * after the interaction is complete.
 */
function PromptForSaveFile(props) {
    return __awaiter(this, void 0, void 0, function* () {
        return utilities_1.ShowReactPromise((resolve, reject) => {
            const modalProps = Object.assign(Object.assign({}, props), { Show: true, Context: {
                    Type: "SaveFile",
                    OnSubmit: resolve
                } });
            return React.createElement(FileBrowserModal, Object.assign({}, modalProps));
        });
    });
}
exports.PromptForSaveFile = PromptForSaveFile;
function GetDefaultTitle(context) {
    switch (context.Type) {
        case "MoveToFolder":
            return `Please choose destination folder for ${context.ItemsToMove.length > 1 ? context.ItemsToMove.length + " items" : context.ItemsToMove[0].Path.Name}`;
        case "SaveFile":
            return `Please choose a file name`;
        case "OpenFile":
            return "Please choose a file";
        case "OpenFolder":
            return "Please choose a folder";
        default:
            utilities_1.HandleNever(context, "FileBrowserContext.Type");
    }
}
//# sourceMappingURL=file-browser-modal.js.map